// routes
import Router from './routes';

// ----------------------------------------------------------------------

export default function App() {
  return <Router />;
}
